import request from '@utils/request'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
    /**
     * @description 新增or編輯分潤
     * @returns 
     */
    addEditCommission({ commit }, query) {
        return request.post('/admin/commission/store', query)
    },
    /**
     * @description 移除分潤人員
     * @returns 
     */
    removeCommission({ commit }, query) {
        return request.post('/admin/commission/remove', query)
    },
}
